// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper {
  width: 408px !important;
}
.insufficient-title {
  font-size: 28px;
  font-weight: 800;
  line-height: 38px;
  text-align: center;
}
.insufficient-image {
  width: 179px;
  height: 126px;
  margin: 38px auto 34px;
}
.insufficient-lastBtn {
  margin-block: 24px 14px;
}
@media screen and (max-width: 452px) {
  .modal-wrapper {
    width: 310px !important;
  }
  .insufficient-title {
    font-size: 24px;
    line-height: 32px;
  }
  .insufficient-image {
    margin-block: 30px;
  }
  .insufficient-btn {
    height: 48px;
  }
  .insufficient-btn > span {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cashier/InsufficientBalanceModal/style.less"],"names":[],"mappings":"AACA;EACE,uBAAA;AAAF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AAME;EACE,uBAAA;AAJJ;AAQA;EACE;IACE,uBAAA;EANF;EAUE;IACE,eAAA;IACA,iBAAA;EARJ;EAWE;IACE,kBAAA;EATJ;EAYE;IACE,YAAA;EAVJ;EASE;IAII,eAAA;IACA,iBAAA;IACA,gBAAA;EAVN;AACF","sourcesContent":["\n.modal-wrapper {\n  width: 408px !important;\n}\n\n.insufficient {\n  &-title {\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 38px;\n    text-align: center;\n  }\n  \n  &-image {\n    width: 179px;\n    height: 126px;\n    margin: 38px auto 34px;\n  }\n\n  &-lastBtn {\n    margin-block: 24px 14px;\n  }\n}\n\n@media screen and (max-width: 452px) {\n  .modal-wrapper {\n    width: 310px !important;\n  }\n\n  .insufficient {\n    &-title {\n      font-size: 24px;\n      line-height: 32px;\n    }\n\n    &-image {\n      margin-block: 30px;\n    }\n\n    &-btn {\n      height: 48px;\n\n      > span {\n        font-size: 20px;\n        line-height: 28px;\n        font-weight: 600;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
